import { Component, OnInit, Inject, Input } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { LookupService } from 'src/app/Services/LookupService';
import { ILookupBase } from 'src/app/Models/ILookupBase';
import { saveAs } from 'node_modules/file-saver/src/FileSaver';
import { ReportService } from 'src/app/Services/ReportService';
import { IReportPDF } from 'src/app/Models/IReportPDF';
import { Globals } from '../../../globals'
import { IServiceProviderSearchParameters } from 'src/app/Models/IServiceProviderSearchParameters';
import { MultiSelectModule } from 'primeng/multiselect';
import { forEach } from 'core-js/library/js/array';

@Component({
  selector: 'app-IEPSummary',
  templateUrl: './IEPSummary.component.html',
  styleUrls: ['./IEPSummary.component.css']
})
export class IEPSummaryComponent implements OnInit {

  _baseUrl: string;
  _myGlobals: Globals;

  date: Date; //datepicker

  //dropdowns
  selectedPAU: SelectItem;
  selectedSite: SelectItem;
  selectedServiceProvider: SelectItem;
  selectedStudent: SelectItem;
  _PAUid: string = null;
  _siteId: string = null;
  _serviceProviderValue: string = null;
  selectedStudents: ILookupBase[] = [];
  _spinnerWhileMessage: string;
  showRefreshSpinner: boolean;
  _showPrintOptions: boolean;
  _startDate: string = null;
  _viewReportButtonEnabled: boolean = false;
  showSpinner: boolean = false;

  //lookups
  lookupSite: any = [];
  lookupSiteName: string;
  lookupSiteAddress: string;
  lookupSiteList: ILookupBase[] = [{ value: null, label: "-- Select PAU to view sites --", shortText: null, updatedOn: null }];
  lookupPAUList: ILookupBase[] = [{ value: null, label: "-- ALL PAUs --", shortText: null, updatedOn: null }];
  lookupSProvidersList: ILookupBase[] = [{ value: null, label: "-- NO SERVICE PROVIDERS ! --", shortText: null, updatedOn: null }];
  lookupStudentList: ILookupBase[] = []; 
  _lookupService: LookupService;
  _reportService: ReportService;

  constructor(lookupService: LookupService, reportService: ReportService, globals: Globals,
    @Inject('BASE_URL') baseUrl: string
  ) {
    this._lookupService = lookupService;
    this._reportService = reportService;
    this._baseUrl = baseUrl;
    this._myGlobals = globals;
  }

  ngOnInit() {
    let today = new Date();
    this.date = new Date(today.getMonth() + 1 + '/' + today.getDate() + '/' + today.getFullYear());
    this.LoadLookupValues();
  }

  LoadLookupValues(): void {
    this._lookupService.getLookupPAUs(this._baseUrl + 'api/Lookup/GetLookupPauList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10))
      .subscribe((res: ILookupBase[]) => {
        this.lookupPAUList = [{ value: null, label: "-- ALL PAUs --", shortText: null, updatedOn: null }].concat(res);
        this.selectedPAU = this.lookupPAUList[0];
        this._lookupService.getLookupSites(this._baseUrl + 'api/Lookup/GetLookupSiteList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10) + '^' + '')
          .subscribe((res: ILookupBase[]) => {
            if (!res || res.toString() === "") {
              this.lookupSiteList = [{ value: null, label: "-- NO SITES TO VIEW ! --", shortText: null, updatedOn: null }]
            }
            else {
              this.lookupSiteList = [{ value: null, label: "-- All Sites --", shortText: null, updatedOn: null }].concat(res);
              this.selectedSite = this.lookupSiteList[0];

              //Service Provider Lookup
              let serviceProviderParams: IServiceProviderSearchParameters = {} as IServiceProviderSearchParameters;
              serviceProviderParams.startDate = this.date;
              serviceProviderParams.endDate = this.date;
              serviceProviderParams.siteIdArray = this.getSiteIdList().split('^');

              this._lookupService.getLookupServiceProviders(this._baseUrl + 'api/Lookup/GetServiceProviderList/', serviceProviderParams)
                .subscribe((res: ILookupBase[]) => {
                  if (!res || res.toString() === "") {
                    this.lookupSProvidersList = [{ value: null, label: "-- NO SERVICE PROVIDERS ! --", shortText: null, updatedOn: null }]
                  }
                  else {
                    this.lookupSProvidersList = [{ value: null, label: "-- ALL Service Providers --", shortText: null, updatedOn: null }].concat(res);
                    this.selectedServiceProvider = this.lookupSProvidersList[0];

                    // Student Lookup
                    if (this.selectedServiceProvider.value != null) {
                      this._lookupService.getIEPSummaryReportCriteriaForProvider(this._baseUrl + 'api/Lookup/GetIEPSummaryReportCriteriaForProvider/?providerId=' + this.selectedServiceProvider.value)
                        .subscribe((res: ILookupBase[]) => {
                          if (!res || res.toString() === "") {
                            this.lookupStudentList = []; 
                          } else if (this.selectedServiceProvider.value == null) {
                            this.lookupStudentList = [].concat(res);
                            this.selectedStudent = this.lookupStudentList[0];
                          }
                        });
                      }
                  }
                },
                  err => console.error(err)
              );

            }
          },
            err => console.error(err)
          );
      },
        err => console.error(err)
      );
  }

  LookupSites(id): void {
    this._PAUid = id.value;
    var param = (typeof id == "string") ? id : (id.value != null ? id.value : '');
    this._lookupService.getLookupSites(this._baseUrl + 'api/Lookup/getLookupSiteList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10) + '^' + param)
      .subscribe((res: ILookupBase[]) => {
        if (!res || res.toString() === "") {
          this.lookupSiteList = [{ value: null, label: "-- NO SITES TO VIEW ! --", shortText: null, updatedOn: null }]
        }
        else {
          this.lookupSiteList = [{ value: null, label: "-- All Sites --", shortText: null, updatedOn: null }].concat(res);
          this.selectedSite = this.lookupSiteList[0];
        }
      },
        err => console.error(err)
      );
  }

  setServiceProvider(id): void {
    this._serviceProviderValue  = id.value;
    // Student Lookup
    if (this._serviceProviderValue != null) {
      this._lookupService.getIEPSummaryReportCriteriaForProvider(this._baseUrl + 'api/Lookup/GetIEPSummaryReportCriteriaForProvider/?providerId=' + this._serviceProviderValue)
        .subscribe((res: ILookupBase[]) => {
          if (!res || res.toString() === "") {
            this.lookupStudentList = []; 
          } else if (this.selectedServiceProvider.value == null) {
            this.lookupStudentList = [].concat(res);
            if (this.lookupStudentList.length > 0) {
              this.selectedStudent = this.lookupStudentList[0];
            }
          }
        });
    }
    else if (this.selectedSite != null) {
      this.getStudentsBySite(this._siteId);
    }
    else {
      this.lookupStudentList = []; 
      this._viewReportButtonEnabled = this.lookupStudentList[0].value != null;
    }
    this.selectedStudents = [];
    this._viewReportButtonEnabled = false;
  }

  getSiteIdList(): string {
    if (this._siteId != null) { return this._siteId }
    else {
      let siteIdList: string;
      this.lookupSiteList.forEach((site, index, arr) => {
        if ((site.label != null) && (site.label != "-- Select PAU to view sites --") && (site.label != "-- NO SITES TO VIEW --")) {
          if (site.label != "-- All Sites --") siteIdList += site.value + '^';
        }
      });
      return siteIdList.slice(0, siteIdList.length - 1).replace('undefined', '');
    }
  }

  setSite(id): void {
    this._siteId = id.value;
    this.getServiceProviderList();
    this.getStudentsBySite(this._siteId);
  }

  getServiceProviderList(): void {
    //Service Provider Lookup
    let serviceProviderParams: IServiceProviderSearchParameters = {} as IServiceProviderSearchParameters;
    serviceProviderParams.startDate = this.date;
    serviceProviderParams.endDate = this.date;
    serviceProviderParams.siteIdArray = this.getSiteIdList().split('^');

    this._lookupService.getLookupServiceProviders(this._baseUrl + 'api/Lookup/GetServiceProviderList/', serviceProviderParams)
      .subscribe((res: ILookupBase[]) => {
        if (!res || res.toString() === "") {
          this.lookupSProvidersList = [{ value: null, label: "-- NO SERVICE PROVIDERS ! --", shortText: null, updatedOn: null }]
        }
        else {
          this.lookupSProvidersList = [{ value: null, label: "-- ALL Service Providers --", shortText: null, updatedOn: null }].concat(res);
          this.selectedServiceProvider = this.lookupSProvidersList[0];

          // Student Lookup
          if (this.selectedServiceProvider.value != null) {
            this._lookupService.getIEPSummaryReportCriteriaForProvider(this._baseUrl + 'api/Lookup/GetIEPSummaryReportCriteriaForProvider/?providerId=' + this.selectedServiceProvider.value)
              .subscribe((res: ILookupBase[]) => {
                if (!res || res.toString() === "") {
                  this.lookupStudentList = []; 
                } else if (this.selectedServiceProvider.value == null) {
                  this.lookupStudentList = [].concat(res);
                  this.selectedStudent = this.lookupStudentList[0];
                }
              });
          }
        }
      },
        err => console.error(err)
      );
  }

  getStudentsBySite(siteId) {
    this._lookupService.getIEPSummaryReportCriteriaForSite(siteId).subscribe((res: ILookupBase[]) => {
      if (!res || res.toString() === "") {
        this.lookupStudentList = [];
      } else {
        this.lookupStudentList = [].concat(res);
        if (this.lookupStudentList.length > 0) {
          this.selectedStudent = this.lookupStudentList[0];
        }
      }
    });
  }

  selectedStudentsChanged(event): void {
    this._viewReportButtonEnabled = this.selectedStudents.length > 0;
  }

  viewReport() {
    this.selectedStudents = [...new Set(this.selectedStudents)]

    if (this.selectedStudents.length > 0 && this.selectedStudents[0].value != '') {
      var iepInstancePSV = '';
      var j = this.selectedStudents.length;
      for (var i = 0; i < j; i++) {
        iepInstancePSV = iepInstancePSV + `${this.selectedStudents[i]}|`;
      }

      this.showSpinner = true;
      this._reportService.getStitchedIEPSummaryPdfReport(iepInstancePSV).subscribe((res: IReportPDF) => {
        var binaryString = window.atob(res.base64FileContent);
        var stringLength = binaryString.length;
        var bytes = new Uint8Array(stringLength);
        for (var i = 0; i < stringLength; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        this.showSpinner = false;

        let now = new Date();
        let localReportFileName = '130-IEPSummary_' + now.toISOString().slice(0, 10) + '_' + now.toTimeString().slice(0, 5) + '.pdf';
        saveAs(new Blob([bytes], { type: 'application/pdf' }), localReportFileName);
      },
        err => {
          this.showSpinner = false;
          console.error(err);
        }
      );
    }
  }

  showPrintOptions() {
    this._showPrintOptions = true;
  }

}
